import React, {Component} from 'react';
import { observer, inject } from 'mobx-react';
import {Row, Column} from '../global/grid/grid';

import { CityMenuWrapper } from './styled-components';

@inject("store")
@observer class CityMenu extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick() {
        const { store, onClick } = this.props;
        store.csMenuToggle();
        onClick();
    }
    render() {
        const {data, onClick, store} = this.props;
        return (
            <CityMenuWrapper>
                <Row margins={false} style={{width: '100%'}}>
                    <Column cw={12} style={{display: 'flex', justifyContent: 'center'}}>
                        <span onClick={this.onClick}>
                            <span className="city">{ store.csCity }, </span>
                            <span className="state">{ store.csState }</span>
                            <div className={`arrow ${store.csMenu ? 'active' : ''}`}></div>
                        </span>
                    </Column>
                </Row>
            </CityMenuWrapper>
        )
    }
}

export default CityMenu;



// WEBPACK FOOTER //
// ./src/components/header/CityMenu.js